// GTM Event Types
export interface GTMEvent {
  event: string;
  page_path?: string;
  page_title?: string;
  form_step?: number;
  total_steps?: number;
  age?: string;
  gender?: string;
  coverage_amount?: string;
  quotes_count?: number;
  selected_company?: string | null;
  selected_rate?: string | null;
  motivations?: string[];
  beneficiary?: string;
  coverage_start?: string;
  health?: string;
  [key: string]: any;
}

// Event Names
export const GTM_EVENTS = {
  QUESTIONNAIRE_VIEW: 'questionnaire_view',
  QUOTE_RESULTS_VIEW: 'quote_results_view',
  APPLICATION_VIEW: 'application_view',
} as const;

// Type-safe window.dataLayer
declare global {
  interface Window {
    dataLayer: GTMEvent[];
  }
}

// Initialize dataLayer
export const initializeGTM = () => {
  window.dataLayer = window.dataLayer || [];
  
  try {
    // Push initial event to trigger Google Ads tag
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
      'ads.enabled': true,
      'google_tag_params': {
        'allow_custom_scripts': true,
        'send_page_view': true
      }
    });
  } catch (error) {
    console.error('Error initializing GTM:', error);
  }
};

// Push event to dataLayer
export const pushGTMEvent = (event: GTMEvent) => {
  if (typeof window !== 'undefined') {
    try {
      // Push to GTM
      window.dataLayer.push(event);
      
      // Notify parent window if in iframe
      if (window !== window.parent) {
        try {
          window.parent.postMessage({
            type: 'GTM_EVENT',
            event: event
          }, 'https://emma.ca');
        } catch (error) {
          console.error('Error posting message to parent window:', error);
        }
      }
    } catch (error) {
      console.error('Error pushing GTM event:', error);
    }
  }
};

// Page view event helper
export const trackPageView = (pagePath: string, pageTitle: string) => {
  try {
    let eventName: string;

    switch (pagePath) {
      case '/':
        eventName = GTM_EVENTS.QUESTIONNAIRE_VIEW;
        break;
      case '/result':
        eventName = GTM_EVENTS.QUOTE_RESULTS_VIEW;
        break;
      case '/apply':
        eventName = GTM_EVENTS.APPLICATION_VIEW;
        break;
      default:
        eventName = 'page_view';
    }

    // Use the dataLayer approach instead of direct fetch
    pushGTMEvent({
      event: eventName,
      page_path: pagePath,
      page_title: pageTitle
    });

    // We don't need to manually fetch GTM URLs - the GTM script handles this
    // This prevents the "Invalid URL" error
  } catch (error) {
    console.error('Error tracking page view:', error);
  }
};